import React from 'react';
import { Blurhash } from 'react-blurhash';
import { ErrorBoundary } from 'react-error-boundary';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import sendErrorReport from 'common/utils/sendErrorReport';

type Props = {
  src: string;
  alt: string;
  blurhash: string;
  draggable?: boolean;
};

const Root = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  justify-content: center;
`;

const BlurhashContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

const Image = styled(LazyLoadImage)`
  object-fit: contain;
  height: 100%;
  width: 100%;
`;

export const LazyImage = ({ src, alt, blurhash }: Props) => {
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  return (
    <Root>
      {!isImageLoaded && (
        <ErrorBoundary FallbackComponent={() => null} onError={error => sendErrorReport(error, 'blurhash')}>
          <BlurhashContainer>
            <Blurhash hash={blurhash} width="100%" height="100%" />
          </BlurhashContainer>
        </ErrorBoundary>
      )}
      <Image src={src} alt={alt} onLoad={() => setIsImageLoaded(true)} />
    </Root>
  );
};
